(function() {
    'use strict';

    angular.module('GorillaBoy')
    .controller('passcodeController', [
        '$q',
        '$rootScope',
        '$scope',
        '$translate',
        '$uibModalInstance',
        '$route',
        'DocumentService',
        'MessageManager',
        'isAnonymousCall',
        '$log',
        passcodeCtrl
    ]);

    function passcodeCtrl($q, $rootScope, $scope, $translate, $uibModalInstance, $route, 
    		documentService, MessageManager, isAnonymousCall, $log) {
    	
    	var docId = $route.current.params.documentId;
    	
    	activate();
    	
    	function activate(){
    		
    		$scope.submitPassword = function(form) {
    			
    			$scope.incorrectData = false;
    			form.passcodeInput.$setPristine();
        		
        		documentService.getDocument(docId, true, $scope.passcode, isAnonymousCall)
                .then(function(document){
                
                	document.passcode = $scope.passcode;
                	form.passcodeInput.$setDirty();
                	form.passcodeInput.$setValidity("passcodeInput", true);
                	$uibModalInstance.close(document);
                
                }, function(error){
                	
                	$scope.incorrectData = true;
                	form.passcodeInput.$setDirty();
                	form.passcodeInput.$setValidity("passcodeInput", false);
                	$log.error(error.data.Message);
                });
        		
        	};
        	
    	}
    	
    }
    
}());
    
